import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IChangeOrderModel } from '@/models/changeOrder.models';

@Component({
   selector: 'change-order-list',
   templateUrl: './changeOrderList.template.html',
   host: {'class': 'change-order-list-component', id: 'sidebar-content'}
})

export class ChangeOrderListComponent {
    @Input()
    model: Array<IChangeOrderModel> = new Array<IChangeOrderModel>();

    @Input()
    selectedChangeOrderId: string = null;

    @Input()
    showIndicator: boolean = false;

    @Output()
    onChangeOrderSelect: EventEmitter<IChangeOrderModel> = new EventEmitter<IChangeOrderModel>();

    selectChangeOrder(changeOrder: IChangeOrderModel): void {
        this.onChangeOrderSelect.emit(changeOrder);
    }
}
